import * as React from "react";
import { styled } from "@mui/material/styles";
import { Checkbox, CheckboxProps, FormControlLabel, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const CheckboxOfferz = styled((props: CheckboxProps & { disabled: boolean }) => (
  <Checkbox
    disableRipple
    focusRipple={false}
    icon={<span />}
    checkedIcon={<CheckIcon style={{ color: "#fff" }} />}
    {...props}
  />
))(({ theme, disabled }) => ({
  width: 20,
  height: 20,
  top: 0,
  background: "#fff",
  marginRight: "10px",
  border: "1px solid #ddd",
  borderRadius: 4,
  opacity: disabled ? 0.6 : 1,
  "&.Mui-checked": {
    border: "none",
  },
  "& .MuiSvgIcon-root": {
    width: 20,
    height: 20,
    borderRadius: 4,
  },
  "&.Mui-checked .MuiSvgIcon-root": {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));

interface CustomCheckboxProps {
  labelComponents: React.ReactNode | string | (React.ReactNode | string)[];
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  disabled?: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  labelComponents,
  name,
  checked,
  onChange,
  disabled = false,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled && onChange) {
      onChange(event);
    }
  };

  return (
    <FormControlLabel
      control={
        <CheckboxOfferz
          disabled={disabled}
          name={name}
          checked={checked}
          onChange={handleChange}
          className={checked || disabled ? "" : "shadow-sm"}
        />
      }
      label={
        typeof labelComponents === "string" ? (
          <Typography component="span" sx={{ fontSize: "13px" }}>
            {labelComponents}
          </Typography>
        ) : (
          <Typography component="span" sx={{ fontSize: "13px", display: "inline-block" }}>
            {Array.isArray(labelComponents)
              ? labelComponents.map((component, index) => (
                  <React.Fragment key={index}>{component}</React.Fragment>
                ))
              : labelComponents}
          </Typography>
        )
      }
      sx={{
        "&:hover": {
          cursor: disabled ? "not-allowed" : "pointer",
        },
        "&.MuiFormControlLabel-root": {
          mx: 0,
          display: "flex",
          alignItems: "flex-start",
        },
      }}
    />
  );
};

export default CustomCheckbox;
